import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  width: 40rem;
  padding: 1.5rem 0;
`;

const Title = styled(Headline)`
  padding: 0 1.5rem;
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 2rem 1.5rem;
  margin: 1.5rem 0;
  border-top: 0.1rem solid ${pickColor('gray')};
  border-bottom: 0.1rem solid ${pickColor('gray')};
`;

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
  font-size: 1.4rem;
`;

const RadioInput = styled.input`
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.2rem;
  padding-right: 1.5rem;
`;

export { Container, Title, OptionsWrapper, OptionLabel, RadioInput, ButtonWrapper };
